import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, ViewType } from '../../../../grid/gridView/types';
import {
  getColumnDetails,
  DISPLAYED_COLUMNS,
  DISPLAYED_FILTERS,
  IntegrityMonitorEventsWebComponentSchema,
} from '../types';
import { sanitizeObject } from '../../../../utils/sanitization.utils';

export class IntegrityMonitorEventsDataProvider extends BaseWebComponentDataProvider {
  public async getDataForView(): Promise<IntegrityMonitorEventsWebComponentSchema> {
    const view = {
      id: 'integrity-monitor-inner-grid',
      name: 'Default integrity monitor grid',
      type: ViewType.DEFAULT,
      filters: DISPLAYED_FILTERS,
      displayedColumns: DISPLAYED_COLUMNS,
      pageSize: DEFAULT_PAGE_SIZE,
      pageNumber: DEFAULT_PAGE_NUMBER,
      selectedTargets: [
        {
          companyId: 'vagrant',
          companyName: 'Vagrant',
        },
      ],
      compactView: false,
    };

    return {
      views: [view],
      allColumns: getColumnDetails(this.dependencies.translateFn),
      defaultViewProps: view,
    };
  }

  public async updateCategories(records: Array<any>, newCategory: string): Promise<any> {
    try {
      const response = await this.dependencies.api.clients.IntegrityMonitorEvents.updateRecords(
        records,
        newCategory
      ).toPromise();

      return sanitizeObject(response);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
